import React from "react";

function Skill() {
  return (
    <div>
      {/* <center> */}
      <div
        className="skill-body shadow"
        style={{
          minHeight: "65vh",
          overflow: "hidden",
        }}
      >
        <h3
          style={{
            color: "white",
            position: "relative",
            left: "20px",
            overflow: "hidden",
            top: "30px",
          }}
          className="skill-text"
        >
          {" "}
          My Skills
        </h3>
        <div className="line"></div>

        <ul
          class="list-group"
          style={{
            width: "90%",
            padding: "10px",
            marginLeft: "10px",
            position: "relative",
            top: "20px",
          }}
        >
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <span
              style={{
                marginLeft: "",
                color: "orangered",
                fontSize: "15px",
                fontFamily: "serif",
              }}
            >
              HTML
              <i className="fab fa-html5"></i>
            </span>
            <div
              class="progress"
              role="progressbar"
              aria-label="Animated striped example"
              aria-valuenow="65"
              aria-valuemin="0"
              aria-valuemax="90"
              style={{ width: "45%" }}
            >
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                style={{ width: "95%" }}
              ></div>
            </div>
            <span class="badge bg-primary rounded-pill">95%</span>
          </li>
        </ul>
        {/*  */}
        <ul
          class="list-group"
          style={{
            width: "80%",
            padding: "10px",
            marginLeft: "10px",
            position: "relative",
            top: "20px",
          }}
        >
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <span
              style={{
                marginLeft: "5px",
                color: "teal",
                fontSize: "15px",
                fontFamily: "serif",
              }}
            >
              CSS
              <i className="fab fa-css3"></i>
            </span>
            <div
              class="progress"
              role="progressbar"
              aria-label="Animated striped example"
              aria-valuenow="65"
              aria-valuemin="0"
              aria-valuemax="90"
              style={{ width: "45%" }}
            >
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                style={{ width: "80%" }}
              ></div>
            </div>
            <span class="badge bg-primary rounded-pill">80%</span>
          </li>
        </ul>
        {/*  */}
        <ul
          class="list-group"
          style={{
            width: "75%",
            padding: "10px",
            marginLeft: "10px",
            position: "relative",
            top: "20px",
          }}
        >
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <span
              style={{
                marginLeft: "5px",
                color: "crimson",
                fontSize: "15px",
                fontFamily: "serif",
                position: "relative",
                right: "10px",
              }}
            >
              JAVASCRIPT
              {/* <i className="fab fa-js"></i> */}
            </span>
            <div
              class="progress"
              role="progressbar"
              aria-label="Animated striped example"
              aria-valuenow="65"
              aria-valuemin="0"
              aria-valuemax="90"
              style={{ width: "45%" }}
            >
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                style={{ width: "75%" }}
              ></div>
            </div>
            <span class="badge bg-primary rounded-pill">75%</span>
          </li>
        </ul>
        {/*  */}
        <ul
          class="list-group"
          style={{
            width: "80%",
            padding: "10px",
            marginLeft: "10px",
            position: "relative",
            top: "20px",
          }}
        >
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <span
              style={{
                marginLeft: "5px",
                color: "blue",
                fontSize: "15px",
                fontFamily: "serif",
              }}
            >
              REACTJS
              <i className="fab fa-react"></i>
            </span>
            <div
              class="progress"
              role="progressbar"
              aria-label="Animated striped example"
              aria-valuenow="65"
              aria-valuemin="0"
              aria-valuemax="90"
              style={{ width: "45%" }}
            >
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                style={{ width: "80%" }}
              ></div>
            </div>
            <span class="badge bg-primary rounded-pill">80%</span>
          </li>
        </ul>
        {/*  */}
        <ul
          class="list-group"
          style={{
            width: "80%",
            padding: "10px",
            marginLeft: "10px",
            position: "relative",
            top: "20px",
          }}
        >
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <span
              style={{
                marginLeft: "5px",
                color: "black",
                fontSize: "15px",
                fontFamily: "serif",
                fontWeight: "bolder",
              }}
            >
              SASS
              <i className="fab fa-sass"></i>
            </span>
            <div
              class="progress"
              role="progressbar"
              aria-label="Animated striped example"
              aria-valuenow="65"
              aria-valuemin="0"
              aria-valuemax="90"
              style={{ width: "45%" }}
            >
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                style={{ width: "80%" }}
              ></div>
            </div>
            <span class="badge bg-primary rounded-pill">80%</span>
          </li>
        </ul>
        {/*  */}
        <ul
          class="list-group"
          style={{
            width: "95%",
            padding: "10px",
            marginLeft: "10px",
            position: "relative",
            top: "20px",
          }}
        >
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <span
              style={{
                marginLeft: "5px",
                color: "purple",
                fontSize: "15px",
                fontFamily: "serif",
              }}
            >
              BOOTSTRAP
              <i className="fab fa-bootstrap"></i>
            </span>
            <div
              class="progress"
              role="progressbar"
              aria-label="Animated striped example"
              aria-valuenow="65"
              aria-valuemin="0"
              aria-valuemax="90"
              style={{ width: "45%" }}
            >
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                style={{ width: "95%" }}
              ></div>
            </div>
            <span class="badge bg-primary rounded-pill">95%</span>
          </li>
        </ul>

        {/* <h2
          className="add"
          style={{ marginTop: "10px", color: "red", fontSize: "20px" }}
        >
          **Additional Skills**
        </h2>
        
        <h3 style={{ textTransform: "uppercase", fontSize: "15px" }}>
          Typescript
        </h3>
        <h3 style={{ textTransform: "uppercase", fontSize: "15px" }}>
          J-query
        </h3>
        <h3 style={{ textTransform: "uppercase", fontSize: "15px" }}>
          Git and Github
        </h3>
        <h3 style={{ textTransform: "uppercase", fontSize: "15px" }}>
          Netlify
        </h3>
        <h3 style={{ textTransform: "uppercase", fontSize: "15px" }}>
          Typescript
        </h3>
        <h3 style={{ textTransform: "uppercase", fontSize: "15px" }}>vercel</h3> */}
      </div>
      {/* </center> */}
    </div>
  );
}

export default Skill;
